import React, { useEffect } from "react";
import Layout from "../components/organisms/Layout";
import Hero from "../components/pages/index/Hero";
import Service from "../components/pages/index/Service";
import Quote from "../components/pages/index/Quote";
import Brand from "../components/pages/index/Brand";
import Insurance from "../components/molecules/InsuranceList";
import Contact from "../components/pages/index/Contact";
import { ShowNavDropdown } from "../hooks";
import SEO from '../components/seo';

const Index = () => {
	useEffect(() => {
		ShowNavDropdown();
	}, []);
	return (
		<>
			<SEO />
			<Layout landingPage='person'>
				<Hero page='person' />
				<Service />
				<Quote />
				<Brand />
				<Insurance type='persons' />
				{/* <Contact /> */}
			</Layout>
		</>
	);
};

export default Index;
